module.exports = __webpack_public_path__ + "static/media/img.da2e6aa7.svg";